import Icon from '../components/Icon.vue'

Icon.register({
  atom: {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M413 256c40.1 54.9 41.5 98.6 25.1 128-29.2 52.3-101.7 43.6-116.3 41.9-21.5 51.2-54.2 86.1-97.8 86.1s-76.4-34.9-97.8-86.1c-14.7 1.7-87.1 10.5-116.3-41.9-16.4-29.4-15-73.1 25.1-128-40.1-54.9-41.5-98.6-25.1-128 10.9-19.5 40.6-50.7 116.3-41.9 21.5-51.2 54.2-86.1 97.8-86.1s76.4 34.9 97.8 86.1c75.8-8.9 105.4 22.4 116.3 41.9 16.4 29.4 15 73.1-25.1 128zM63.4 352c3.7 6.6 19 11.9 43.6 11-2.8-13-5-26.4-6.8-40.1-7.7-6.3-14.9-12.6-21.9-19.2-15.1 23.5-19 41.1-15 48.3zM100.2 189.1c1.4-11.2 4.4-29.2 6.8-40.2-1.8-0.1-4-0.4-5.7-0.4-21.5 0-34.5 5.3-37.9 11.5-4 7.2-0.2 24.8 15 48.3 7-6.5 14.2-12.9 21.9-19.2zM224 64c-9.5 0-22.2 13.5-33.9 37.3 11.2 3.7 22.4 8 33.9 12.9 11.4-4.9 22.7-9.2 33.9-12.9-11.7-23.7-24.4-37.3-33.9-37.3zM224 448c9.5 0 22.2-13.5 33.9-37.3-11.2-3.7-22.4-8-33.9-12.9-11.4 4.9-22.7 9.2-33.9 12.9 11.7 23.7 24.4 37.3 33.9 37.3zM286.5 290.7c2-27.8 2-41.5 0-69.3-26.6-19-46.1-29.3-62.5-37.5-16.4 8.2-35.8 18.4-62.5 37.5-2 27.8-2 41.5 0 69.3 26.7 19.1 46.2 29.3 62.5 37.5 16.4-8.2 35.8-18.4 62.5-37.5zM384.6 352c4-7.2 0.2-24.8-15-48.3-7 6.5-14.2 12.9-21.9 19.2-1.7 13.7-4 27.1-6.8 40.1 24.6 0.9 39.9-4.3 43.6-11zM369.7 208.3c15.1-23.5 19-41.1 15-48.3-3.4-6.1-16.4-11.5-37.9-11.5-1.7 0-3.9 0.3-5.7 0.4 2.4 11 5.4 29 6.8 40.2 7.7 6.3 14.9 12.6 21.9 19.2zM224 224c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/atom.js
// module id = 634
// module chunks = 0